import React from "react";
import { Table } from "antd";

const AssociatedPayments = ({ dataSource }) => {
  // Define columns for the table
  const columns = [
    {
      title: "Booking ID",
      dataIndex: "bookingId",
      key: "bookingId",
    },
    {
      title: "Bill Amount",
      dataIndex: "billAmount",
      key: "billAmount",
      render: (amount) => `₹ ${amount.toLocaleString()}`,
    },
    {
      title: "Payment Method",
      dataIndex: "method",
      key: "method",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) =>
        status === "SUCCESS" ? (
          <span style={{ color: "green" }}>{status}</span>
        ) : (
          <span style={{ color: "red" }}>{status}</span>
        ),
    },
    {
      title: "Date",
      key: "paymentDate",
      render: (_, record) => {
        const dateVal = record.dateOfPayment || record.createdAt;
        return dateVal ? new Date(dateVal).toLocaleString() : "-";
      },
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={dataSource.map((item) => ({ ...item, key: item.id }))}
      pagination={{ pageSize: 5 }}
      bordered
    />
  );
};
export default AssociatedPayments;
